<template lang="pug">
  div
    ods-table(
      v-loading="isloadingCuponesTable"
      style='width: 100%'
      :height="mediaAltura ? '210px' : '400px'"
      size="medium"
      :data='tableDataToRender')
      ods-table-column(prop='PLANTILLA' :label="$t('loyalty.template')")
        template(slot-scope="scope")
          div {{ scope.row.descripcion }}
      ods-table-column(prop='LOYALTYACCOUNT' :label="$t('loyalty.loyaltyAccount')")
        template(slot-scope="scope")
          div {{ scope.row.codcuent }}
      ods-table-column(prop='IDENTIFIER' :label="$t('loyalty.dni')")
        template(slot-scope="scope")
          ods-tag(type="info" size="medium") {{scope.row.destipc}}: {{ scope.row.idclient }}
      ods-table-column(prop='CLIENT' :label="$t('loyalty.client')" sortable)
        template(slot-scope="scope")
          div {{ scope.row.nombre }} {{ scope.row.apellido1 }} {{ scope.row.apellido2 }}
      ods-table-column(prop='FECASINC' :label="$t('loyalty.AsignedCouponDate')" width='180' align="center")
        template(slot-scope="scope")
          div {{ scope.row.fecasig | formatDateLocale }}
      ods-table-column(prop='FECUSO' :label="$t('loyalty.DateUseCoupon')" width='180' align="center")
        template(slot-scope="scope")
          div
            span {{ scope.row.fecuso | formatDateLocale }}
            span {{ formatTime(scope.row.horauso) }}
      ods-table-column(prop='CUPONSITUACION' :label="$t('loyalty.CouponSituation')" )
        template(slot-scope="scope")
          ods-tag(size="medium" :type="scope.row.situacion==='UTILIZADO' ? 'success' : 'warning'") {{ scope.row.situacion==='UTILIZADO' ? $t('loyalty.used') : $t('loyalty.notUsed') }}
    div.footer
      paginator-table(v-if="tableDataToRender!==null"
        :isNextPage="paginationParams.indMasDatos"
        :currentPage="paginationParams.pantPagina"
        @buttonPrevAction="getData(false)"
        @buttonNextAction="getData(true)")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'CuentasTable',
  props: ['params', 'mediaAltura', 'filterText'],
  components: { 'paginator-table': Paginator },
  data () {
    return {
      tableData: null,
      tableDataToRender: null,
      paginationParams: {
        currentPage: 1,
        indMasDatos: 'N',
        claveInicio: 1,
        claveFin: 20
      }
    }
  },
  computed: {
    ...mapGetters({
      typeCoupon: 'getTypeCoupon',
      isloadingCuponesTable: 'isloadingCuponesTable',
      isReloadCoupons: 'isReloadCoupons'
    })
  },
  methods: {
    ...mapActions(['getCouponDetails', 'setReloadCoupons']),
    async getData (pagina) {
      let params = this.params
      if (typeof pagina !== 'undefined') {
        // console.log('paginando')
        params = pagina ? { ...this.params, ...this.paginationParams, avanzar: true } : { ...this.params, ...this.paginationParams, retroceder: true }
      }
      this.getCouponDetails(params).then(resData => {
        // console.log('getCouponDetails params resData', params, resData)
        if (resData && resData.registros && resData.retorno === '000') {
          this.tableData = Array.isArray(resData.registros) ? resData.registros : [resData.registros]
          this.tableDataToRender = this.tableData
          this.paginationParams = {
            pantPagina: resData.pantPagina,
            indMasDatos: resData.indMasDatos,
            claveInicio: resData.claveInicio,
            claveFin: resData.claveFin
          }
        } else {
          this.tableData = null
          this.tableDataToRender = this.tableData
        }
        this.setReloadCoupons(false)
      }).catch(err => {
        console.log('getCouponDetails params error', params, err)
      })
    },
    formatTime (time) {
      const rep = ' - ' + time
      return (rep.replace('.', ':'))
    }
  },
  watch: {
    isReloadCoupons (newVal, oldVal) {
      // console.log('isReloadCoupons', newVal, oldVal)
      if (newVal === true) {
        this.getData()
      }
    },
    async filterText (text) {
      if (this.tableData) {
        this.tableDataToRender = await this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
